import "../../../css/Inputs/AMLInput1.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useId, useState } from "react";

const MobileNumberInput = ({
  id,
  label = "",
  placeholder = "Mobile number",
  value,                        // <-- use the prop
  onChange,
  isRequired = false,
  disabled = false,
  defaultCountry = "GB",
  error = "",
  helpText = "",
}) => {
  const autoId = useId();
  const inputId = id || `aml-mobile-${autoId}`;
  const [touched, setTouched] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);

  // IMPORTANT: react-phone-number-input clears with `undefined`, not ""
  const phoneValue = value || undefined;

  const invalid = touched && phoneValue && !isValidPhoneNumber(phoneValue);

  return (
    <div className={`AML-Input-Container ${invalid || error ? "has-error" : ""}`}>
      {label && (
        <label htmlFor={inputId} className="AML-Input-Label-Container" aria-live="polite">
          <span className="AML-Text-Body">{label}</span>
          {isRequired && <span className="AML-Text-Body Required-Indicator">*</span>}
        </label>
      )}

      <div
        className={`AML-Input1 AML-Text-Body ${hasFocus ? "isFocused" : ""} ${error ? "has-error" : ""}`}
        onFocusCapture={() => setHasFocus(true)}
        onBlurCapture={(e) => {
          if (!e.currentTarget.contains(e.relatedTarget)) {
            setHasFocus(false);
            setTouched(true);
          }
        }}
      >
        <PhoneInput
          id={inputId}
          value={phoneValue}                     
          onChange={(val) => onChange?.(val)}    
          defaultCountry={defaultCountry}
          countries={supportedCountries}
          limitMaxLength
          international
          withCountryCallingCode
          countryCallingCodeEditable={false}
          disabled={disabled}
          aria-invalid={Boolean(invalid || error)}
          className="AML-PhoneInput"
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {(invalid || error || helpText) && (
        <div id={`${inputId}-desc`} className={`AML-Input-Helper ${invalid || error ? "is-error" : ""}`}>
          {/* helper/error text if you want */}
        </div>
      )}
    </div>
  );
};

export default MobileNumberInput;

const supportedCountries = [
  "GB","IE","AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE",
  "US","CA",
  "AR","BR","CL","CO","MX","PE","UY","VE",
  "IN","CN","JP","KR","SG","HK","MY","TH","VN","PH","ID","AU","NZ",
  "AE","SA","QA","KW","BH","OM","ZA","NG","KE","EG",
];
